// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"584239c3","787":"239d985f"}[chunkId] + ".chunk.js";
};